module.exports = __webpack_public_path__ + "operace-nosu_4_before_tn.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures_tn/plasticka-chirurgie/operace-nosu_4_before_tn.jpg
// module id = 1604
// module chunks = 0